import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppProvider, useApp } from '@/context/AppContext';
import { AppLayout } from '@/components/Layout/AppLayout';
import Login from '@/pages/Login';
import LandingPage from '@/pages/LandingPage';
import Onboarding from '@/pages/Onboarding';
import Dashboard from '@/pages/Dashboard';
import Creators from '@/pages/Creators';
import Brands from '@/pages/Brands';
import YouTubePage from '@/pages/YouTube';
import ReelsCreatorPage from '@/pages/ReelsCreator';
import TalkingVideosPage from '@/pages/TalkingVideos';
import BRollLibraryPage from '@/pages/BRollLibrary';
import Publish from '@/pages/Publish';
import Billing from '@/pages/Billing';
import Settings from '@/pages/Settings';
import LibrarySearch from '@/pages/LibrarySearch';
import Templates from '@/pages/Templates';

const AppRoutes = () => {
  const { isAuthenticated, onboardingComplete } = useApp();

  // Not authenticated → Login (also allow /onboarding for new signups)
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  // Authenticated but onboarding not done → Onboarding
  if (!onboardingComplete) {
    return (
      <Routes>
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Routes>
    );
  }

  // Fully authenticated + onboarded → App
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/creators" element={<Creators />} />
        <Route path="/brands" element={<Brands />} />
        {/* Content Tools */}
        <Route path="/youtube" element={<YouTubePage />} />
        <Route path="/reels-creator" element={<ReelsCreatorPage />} />
        <Route path="/talking-videos" element={<TalkingVideosPage />} />
        <Route path="/broll" element={<Navigate to="/broll/vertical" replace />} />
        <Route path="/broll/:orientation" element={<BRollLibraryPage />} />
        {/* Other */}
        <Route path="/library-search" element={<LibrarySearch />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/publish" element={<Publish />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/settings" element={<Settings />} />
        {/* Legacy redirects */}
        <Route path="/drive" element={<Navigate to="/youtube" replace />} />
        <Route path="/create" element={<Navigate to="/reels-creator" replace />} />
        <Route path="/risk" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AppLayout>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <AppRoutes />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: 'hsl(220, 14%, 11%)',
              border: '1px solid hsl(220, 14%, 17%)',
              color: 'hsl(220, 20%, 91%)',
              fontSize: '13px',
            },
          }}
        />
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
